import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

export default class extends Controller {
  connect() {
    this.tomSelect = new TomSelect(this.element, {
      plugins: {
        clear_button: {
          title: 'Remove',
        },
        // dropdown_input: {},
        input_autogrow: {}, // eases grow/shrinking and overflow issues with Bootstrap
        // restore_on_backspace: {},
      },
    });

    if (this.element.dataset['1pIgnore'] !== undefined) {
      this.tomSelect.control_input.setAttribute('data-1p-ignore', 'true');
    }

    // Prevent input events from bubbling to parent forms
    this.tomSelect.control_input.addEventListener('input', (e) => e.stopPropagation());
  }

  disconnect() {
    if (this.tomSelect) {
      this.tomSelect.destroy();
    }
  }
}
